import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { CalendarDays, MapPin, Image as ImageIcon, HardDrive, QrCode, Inbox, Mail } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { HubShell } from "@/components/layout/HubTabs";

// Each tab declares the capability that reveals it. Admin/Owner hold them all.
const ALL_TABS = [
  { key: "events", label: "Events", to: "/admin/manage/events", icon: CalendarDays, cap: "manage_events" },
  { key: "locations", label: "Locations", to: "/admin/manage/locations", icon: MapPin, cap: "manage_locations" },
  { key: "media", label: "Media", to: "/admin/manage/media", icon: ImageIcon, cap: "manage_media" },
  { key: "storage", label: "Storage", to: "/admin/manage/storage", icon: HardDrive, cap: "manage_storage" },
  { key: "qr-codes", label: "QR Codes", to: "/admin/manage/qr", icon: QrCode, cap: "manage_invites" },
  { key: "inquiries", label: "Inquiries", to: "/admin/manage/inquiries", icon: Inbox, cap: "manage_inquiries" },
  { key: "email", label: "Email", to: "/admin/manage/email", icon: Mail, cap: "manage_members" },
];

export default function ManageHub() {
  const { can } = useAuth();
  const [inquiryNew, setInquiryNew] = useState(0);

  useEffect(() => {
    let active = true;
    if (can("manage_inquiries")) {
      api.get("/inquiries/stats").then((r) => { if (active) setInquiryNew(r.data?.new || 0); }).catch(() => {});
    }
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tabs = ALL_TABS.filter((t) => can(t.cap)).map((t) =>
    t.key === "inquiries" ? { ...t, badge: inquiryNew } : t
  );

  return (
    <HubShell
      eyebrow="Manage"
      description="Events, venues, media, storage, QR codes, partner inquiries, and member email."
      testIdPrefix="manage"
      tabs={tabs}
    >
      <Outlet />
    </HubShell>
  );
}
